module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [(_vm.isCurrentVersion(_vm.version.id)) ? _c('md-icon', [_vm._v("label")]) : _c('md-icon', [_vm._v("label_outline")]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.version.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getFormattedDate(_vm.version)))]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.getFormattedDate(_vm.version)))])], 1), _vm._v(" "), ((_vm.user.uid === _vm.ownerUID || _vm.user.uid === _vm.version.creator) && _vm.user.active_pay) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.deleteVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Delete Version")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.uid === _vm.ownerUID && _vm.user.active_pay) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.promoteVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("vertical_align_top")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Make Live")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.setActiveVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("launch")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Show Version")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cc49b46","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/history/version.vue
// module id = 667
// module chunks = 2